"use client";

import React from "react";
import { twMerge } from "tailwind-merge";

interface Props extends React.SVGProps<SVGSVGElement> {}

const IconSpinnerDots: React.FC<Props> = (props) => {
  return (
    <svg
      viewBox="0 0 24 24"
      className={twMerge("h-6 w-6", props.className)}
      {...props}
    >
      <g className="origin-center animate-spin">
        <circle cx="12" cy="2.5" r="1.5" fill="currentColor" opacity=".14" />
        <circle
          cx="16.75"
          cy="3.77"
          r="1.5"
          fill="currentColor"
          opacity=".29"
        />
        <circle
          cx="20.23"
          cy="7.25"
          r="1.5"
          fill="currentColor"
          opacity=".43"
        />
        <circle cx="21.5" cy="12" r="1.5" fill="currentColor" opacity=".57" />
        <circle
          cx="20.23"
          cy="16.75"
          r="1.5"
          fill="currentColor"
          opacity=".71"
        />
        <circle
          cx="16.75"
          cy="20.23"
          r="1.5"
          fill="currentColor"
          opacity=".86"
        />
        <circle cx="12" cy="21.5" r="1.5" fill="currentColor" />
      </g>
    </svg>
  );
};

export default IconSpinnerDots;
